import { Link, useNavigate } from "react-router-dom";
import "@/styles/dashboard.css";
import { useDispatch, useSelector } from "react-redux";
import { addValue } from "@/redux/User";
import UserSection from "../header/UserSection";
import { useEffect, useState } from "react";
import { AiChatBotShortLogo } from "@/assets/AiBotAssets";
import environment from "@/constants/Environment";
import { userSlice } from "@/redux/User";

const OmniSideNav = ({ setRoute }) => {
  const add_class = useSelector((state: any) => state.user.addClass);
  const role = useSelector((state: any) => state.user.role);
  const plan = useSelector((state: any) => state.user.plan);
  const setting = useSelector((state: any) => state.user.settings);
  const [inBuilder, setInBuilder] = useState<boolean>(false);

  const dispatch = useDispatch();
  const router = useNavigate();

  const addvalue = () => {
    dispatch(addValue(add_class ? "" : "app-collapse"));
  };
  // useEffect(() => {
  //   if (window.screen.width < 712) {
  //     document.querySelectorAll(".links ul li").forEach((item) => {
  //       item.addEventListener("click", () => addvalue());
  //     });
  //   }
  // }, []);

  useEffect(() => {
    if (
      (window.screen.width < 1279 ||
        window.location.pathname.includes("/builder")) &&
      !document.querySelector(".main-app")?.classList.contains("app-collapse")
    ) {
      addvalue();
    }
  }, []);

  useEffect(() => {
    if (window.location.pathname.includes("/builder")) setInBuilder(true);
    else setInBuilder(false);
    if (
      window.location.pathname.includes("/builder") &&
      !document.querySelector(".main-app")?.classList.contains("app-collapse")
    ) {
      addvalue();
    }
  }, [setRoute]);

  const handleNavInsideBuilder = (e: any, route: string) => {
    if (inBuilder) {
      e.preventDefault();
      setRoute(route);
    }
  };

  return (
    <div
      className={`left-col sn omni-side-nav ${
        window.location.pathname.includes("/builder") ? "omni-short-nav" : ""
      }`}
    >
      <div className="closing-modal">
        <button onClick={addvalue}>
          <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 1.00714L8.99286 0L5 3.99286L1.00714 0L0 1.00714L3.99286 5L0 8.99286L1.00714 10L5 6.00714L8.99286 10L10 8.99286L6.00714 5L10 1.00714Z"
              fill="#6D6D6D"
            ></path>
          </svg>
        </button>
      </div>
      <div className="sidebar sn">
        <div
          onClick={addvalue}
          className={`line_icon ${
            window.location.pathname.includes("/builder") ? "none" : ""
          }`}
        >
          <svg
            className="wb-svg"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.175 2.08337L5 5.94961L8.825 2.08337L10 3.27947L5 8.33337L0 3.27947L1.175 2.08337Z"
              fill="#666666"
            ></path>
          </svg>

          <svg
            className="fn-svg"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.467 19C17.467 18.8011 17.388 18.6103 17.2474 18.4697C17.1067 18.329 16.916 18.25 16.717 18.25H4.00004C3.80113 18.25 3.61036 18.329 3.46971 18.4697C3.32906 18.6103 3.25004 18.8011 3.25004 19C3.25004 19.1989 3.32906 19.3897 3.46971 19.5303C3.61036 19.671 3.80113 19.75 4.00004 19.75H16.717C16.916 19.75 17.1067 19.671 17.2474 19.5303C17.388 19.3897 17.467 19.1989 17.467 19ZM11.778 5C11.778 4.80109 11.699 4.61032 11.5584 4.46967C11.4177 4.32902 11.227 4.25 11.028 4.25H4.00004C3.80113 4.25 3.61036 4.32902 3.46971 4.46967C3.32906 4.61032 3.25004 4.80109 3.25004 5C3.25004 5.19891 3.32906 5.38968 3.46971 5.53033C3.61036 5.67098 3.80113 5.75 4.00004 5.75H11.028C11.227 5.75 11.4177 5.67098 11.5584 5.53033C11.699 5.38968 11.778 5.19891 11.778 5Z"
              fill="#444444"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.75 12C20.75 11.8011 20.671 11.6103 20.5303 11.4697C20.3897 11.329 20.1989 11.25 20 11.25H4C3.80109 11.25 3.61032 11.329 3.46967 11.4697C3.32902 11.6103 3.25 11.8011 3.25 12C3.25 12.1989 3.32902 12.3897 3.46967 12.5303C3.61032 12.671 3.80109 12.75 4 12.75H20C20.1989 12.75 20.3897 12.671 20.5303 12.5303C20.671 12.3897 20.75 12.1989 20.75 12Z"
              fill="#444444"
              fillOpacity="0.5"
            />
          </svg>
        </div>
        <div
          className="nav-logo flex-cnt"
          style={{ gap: environment().isAI ? "8px" : "2px" }}
          onClick={() => setRoute("/dashboard")}
        >
          {environment().isAI ? (
            <div className="logo-cbb">
              <AiChatBotShortLogo />
            </div>
          ) : (
            <div className="logo-og">
              <NewOmniLogo />
            </div>
          )}
          {environment().isAI ? (
            <h1 className="nav-logo-chatbotbuilder">ChatBot Builder</h1>
          ) : (
            <h1>Omniengage</h1>
          )}
        </div>
        <div className="links">
          <span>Overview</span>
          <ul>
            <Link
              to="/dashboard"
              onClick={(e: any) => handleNavInsideBuilder(e, "/dashboard")}
            >
              <li
                className={
                  window.location.pathname === "/dashboard"
                    ? "home side-active"
                    : "home"
                }
              >
                <OmniHomeIcon />
                <span>Dashboard</span>
                {!!add_class && (
                  <p className="sm-tooltip flex-cnt">
                    <span className="sm-tooltip_text">Dashboard</span>
                  </p>
                )}
              </li>
            </Link>
            <Link
              to="/integration"
              onClick={(e: any) => handleNavInsideBuilder(e, "/integration")}
            >
              <li
                className={
                  window.location.pathname === "/integration"
                    ? "integration side-active"
                    : "integration"
                }
              >
                <OmniIntegrationIcon />
                <span>Integrations</span>
                {!!add_class && (
                  <p className="sm-tooltip flex-cnt">
                    <span className="sm-tooltip_text">Integrations</span>
                  </p>
                )}
              </li>
            </Link>
            {/* <Link
              to="/neurodes/credentials"
              onClick={(e: any) => handleNavInsideBuilder(e, "/neurodes/credentials")}
            >
              <li
                className={
                  window.location.pathname.includes("/neurodes/credentials")
                    ? "credentials side-active"
                    : "credentials"
                }
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 14.5V16.5M7 10.0288C7.47142 10 8.05259 10 8.8 10H15.2C15.9474 10 16.5286 10 17 10.0288M7 10.0288C6.41168 10.0647 5.99429 10.1455 5.63803 10.327C5.07354 10.6146 4.61461 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.61461 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C18.0057 10.1455 17.5883 10.0647 17 10.0288M7 10.0288V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10.0288" stroke="#666666" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>Credentials</span>
                {!!add_class && (
                  <p className="sm-tooltip flex-cnt">
                    <span className="sm-tooltip_text">Credentials</span>
                  </p>
                )}
              </li>
            </Link> */}
            {environment()?.isAI && (
              <Link
                to="/analytics"
                onClick={(e: any) => handleNavInsideBuilder(e, "/analytics")}
              >
                <li
                  className={
                    window.location.pathname === "/analytics"
                      ? "side-active side-active-analysis"
                      : "analysis"
                  }
                >
                  <OmniAnalyticsIcon />
                  <span>Analytics</span>
                  {!!add_class && (
                    <p className="sm-tooltip flex-cnt">
                      <span className="sm-tooltip_text">Analytics</span>
                    </p>
                  )}
                </li>
              </Link>
            )}

            {environment().isAI && (
              <li
                className={`chats ${
                  window.location.pathname === "/chats"
                    ? "side-active side-active-analysis"
                    : ""
                }`}
              >
                {plan?.name === "Free" ? (
                  <>
                    <Link to={""} className="locked-chat">
                      <ChatsIcon />
                      <span>Chats</span>
                      <div className="lock-icon">
                        <LockSvg />
                      </div>
                    </Link>
                    <div className="new-config-tooltip fx fx-d-col gap-8">
                      <p>
                        Your plan does not include this feature. Buy one of our
                        plans to <span>unlock </span>
                        this feature.
                      </p>
                      <a
                        onClick={() => {
                          router("/settings");
                          dispatch(userSlice.actions.setSettings(2));
                        }}
                      >
                        Upgrade Plan
                      </a>
                    </div>
                  </>
                ) : (
                  <>
                    <Link
                      to="/chats"
                      onClick={(e: any) => handleNavInsideBuilder(e, "/chats")}
                    >
                      <ChatsIcon />
                      <span>Chats</span>
                    </Link>
                    {!!add_class && (
                      <p className="sm-tooltip flex-cnt">
                        <span className="sm-tooltip_text">Chats</span>
                      </p>
                    )}
                  </>
                )}
              </li>
              // ) : (
              //   <Link
              //     to="/chats"
              //     onClick={(e: any) => handleNavInsideBuilder(e, "/chats")}
              //   >
              //     <li
              //       className={
              //         window.location.pathname === "/chats"
              //           ? `chats side-active`
              //           : `chats`
              //       }
              //     >
              //       <OmniChatsIcon />
              //       <span>Chats</span>
              //       {!!add_class && (
              //         <p className="sm-tooltip  flex-cnt">
              //           <span className="sm-tooltip_text">Chats</span>
              //         </p>
              //       )}
              //     </li>
              //   </Link>
            )}
            {!environment().isAI && (
              <Link
                to="/audience"
                onClick={(e: any) => handleNavInsideBuilder(e, "/audience")}
              >
                <li
                  className={
                    window.location.pathname === "/audience"
                      ? "audience side-active"
                      : "audience"
                  }
                >
                  <OmniAudienceIcon />
                  <span>Audience</span>
                  {!!add_class && (
                    <p className="sm-tooltip flex-cnt">
                      <span className="sm-tooltip_text">Audience</span>
                    </p>
                  )}
                </li>
              </Link>
            )}
          </ul>
        </div>
      </div>
      <div className="bottom_menu">
        <div className="links">
          {/* <span>Insights</span> */}
          <ul>
            <Link
              to="/settings"
              onClick={(e: any) => handleNavInsideBuilder(e, "/settings")}
            >
              <li
                className={
                  window.location.pathname === "/settings" && setting !== 2
                    ? "settings side-active"
                    : "setings"
                }
                onClick={() => {
                  dispatch(userSlice.actions.setSettings(0));
                }}
              >
                <OmniSettingsIcon />
                <span>Settings</span>
                {!!add_class && (
                  <p className="sm-tooltip flex-cnt">
                    <span className="sm-tooltip_text">Settings</span>
                  </p>
                )}
              </li>
            </Link>
            {role === "admin" && (
              <li
                className={
                  (window.location.pathname === "/settings" ||
                    window.location.pathname === "/plan_expired" ||
                    window.location.pathname === "/trial_expired") &&
                  setting === 2
                    ? "pricing side-active pricing-icon"
                    : "pricing pricing-icon"
                }
                onClick={() => {
                  setRoute("/settings");
                  dispatch(userSlice.actions.setSettings(2));
                }}
              >
                <OmniPricingIcon />
                <span>Pricing</span>
                {!!add_class && (
                  <p className="sm-tooltip flex-cnt">
                    <span className="sm-tooltip_text">Billing</span>
                  </p>
                )}
              </li>
            )}
          </ul>
        </div>
        <UserSection setRoute={setRoute} />
      </div>
    </div>
  );
};

export default OmniSideNav;

const OmniengageLogo = () => {
  return (
    <svg
      width="54"
      height="54"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45.3741 30.4054C47.512 29.4679 50.0516 30.4409 50.5457 32.7226C51.2867 36.1448 51.1705 39.7205 50.176 43.1238C48.7834 47.8892 45.7576 52.0123 41.6292 54.7701C37.5008 57.5279 32.5334 58.7443 27.5979 58.206C22.6624 57.6677 18.0739 55.4091 14.6371 51.8262C11.2003 48.2433 9.13443 43.5649 8.80187 38.6113C8.46931 33.6577 9.89124 28.7451 12.8183 24.735C15.7454 20.7248 19.9908 17.8732 24.81 16.68C28.2517 15.8279 31.8292 15.8605 35.2176 16.7432C37.4767 17.3317 38.3433 19.9096 37.3177 22.0067V22.0067C36.292 24.1038 33.7439 24.891 31.4266 24.6081C29.9056 24.4223 28.3519 24.5123 26.8418 24.8862C23.9502 25.6021 21.403 27.3131 19.6468 29.7192C17.8905 32.1253 17.0373 35.0728 17.2369 38.045C17.4364 41.0171 18.6759 43.8242 20.738 45.9739C22.8001 48.1237 25.5532 49.4788 28.5145 49.8018C31.4758 50.1248 34.4563 49.3949 36.9333 47.7403C39.4103 46.0856 41.2258 43.6118 42.0613 40.7525C42.4977 39.2592 42.6523 37.7107 42.5299 36.1832C42.3436 33.8562 43.2361 31.3429 45.3741 30.4054V30.4054Z"
        fill="#FB5F66"
      ></path>
      <path
        d="M53.1185 23.6639C52.3799 24.2422 50.1861 23.4112 47.814 22.3194C45.9231 23.0419 44.7003 22.6322 47.2581 25.3863C49.1221 27.3934 43.7167 27.1529 40.5963 30.2732C36.5793 34.4384 38.3334 43.7882 33.3978 35.9912C31.538 33.0532 34.1797 42.0226 32.9266 42.3874C31.2648 42.6672 31.4684 40.6416 30.8727 35.8983C30.5888 33.6373 30.2527 35.6886 29.8491 38.1711C31.5761 42.301 31.0061 39.5987 29.7744 41.0952L29.4155 40.6893C29.1159 42.237 28.7841 43.3955 28.4158 43.0272C27.5652 42.1765 26.7057 37.7753 25.551 36.3197L25.3955 36.144C25.4479 36.1964 25.4997 36.2552 25.551 36.3197L29.4155 40.6893C29.5682 39.9008 29.7125 39.0113 29.8491 38.1711C29.3228 36.9127 28.5833 35.0199 27.5843 32.1807C26.5209 27.9698 33.7239 30.3348 36.6549 27.996C39.586 25.6572 40.7038 22.6146 40.2445 19.5203C40.3024 18.4608 44.2585 20.6829 47.814 22.3194C48.4192 22.0881 49.0928 21.7408 49.7329 21.1367C50.1888 20.7063 50.5495 20.2429 50.7828 19.7461L46.7626 13.0023C50.7998 15.6984 51.6303 17.9421 50.7828 19.7461L53.1185 23.6639Z"
        fill="#444444"
      ></path>
      <circle
        cx="47.0261"
        cy="20.4576"
        r="7.51467"
        transform="rotate(-135 47.0261 20.4576)"
        fill="#444444"
      ></circle>
      <circle
        cx="30.155"
        cy="37.3282"
        r="9.0176"
        transform="rotate(-135 30.155 37.3282)"
        fill="#444444"
      ></circle>
    </svg>
  );
};

export const HomeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M9.07861 16.1354H14.8936"
        stroke="#444444"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.3999 13.713C2.3999 8.082 3.0139 8.475 6.3189 5.41C7.7649 4.246 10.0149 2 11.9579 2C13.8999 2 16.1949 4.235 17.6539 5.41C20.9589 8.475 21.5719 8.082 21.5719 13.713C21.5719 22 19.6129 22 11.9859 22C4.3589 22 2.3999 22 2.3999 13.713Z"
        stroke="#444444"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const IntegrationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M17.5946 10.1516C17.5946 9.63563 17.1746 9.20363 16.6586 9.20363H15.8666V6.79163C15.8666 6.27563 15.4466 5.84363 14.9306 5.84363C14.4146 5.84363 13.9946 6.26363 13.9946 6.79163V9.20363H12.1226V6.79163C12.1226 6.27563 11.7026 5.84363 11.1866 5.84363C10.6706 5.84363 10.2506 6.26363 10.2506 6.79163V9.20363H9.41061C8.89461 9.20363 8.47461 9.62363 8.47461 10.1516V12.5876C8.47461 14.7956 10.0226 16.6436 12.0866 17.0876C12.6506 17.1956 13.2746 17.1956 13.9586 17.0876C16.0466 16.6556 17.6186 14.7956 17.6186 12.5756V10.1396L17.5946 10.1516ZM15.7226 12.5876C15.7226 14.0876 14.5106 15.2996 13.0226 15.2996C11.5346 15.2996 10.3226 14.0876 10.3226 12.5876V11.0996H15.7106V12.5876H15.7226Z"
        fill="#444444"
      />
      <path
        d="M21.482 3.54C19.214 1.26 16.202 0 12.998 0C9.79405 0 6.78205 1.26 4.51405 3.54C2.24605 5.82 0.998047 8.904 0.998047 12.132C0.998047 14.928 1.97005 17.628 3.72205 19.788C5.46205 21.912 7.88605 23.388 10.538 23.94C10.73 23.976 10.922 24 11.114 24C11.75 24 12.374 23.784 12.89 23.364C13.55 22.824 13.922 22.02 13.922 21.168V18.48H12.05V21.168C12.05 21.564 11.834 21.792 11.702 21.9C11.486 22.08 11.198 22.152 10.91 22.092C6.24205 21.12 2.85805 16.932 2.85805 12.132C2.87005 6.504 7.41805 1.884 12.998 1.884C18.578 1.884 23.1261 6.456 23.1261 12.072C23.1261 16.188 20.702 19.896 16.946 21.492C16.466 21.696 16.25 22.248 16.454 22.728C16.658 23.208 17.21 23.436 17.678 23.232C19.826 22.32 21.65 20.796 22.958 18.84C24.302 16.836 25.01 14.496 25.01 12.072C25.01 8.844 23.7621 5.808 21.494 3.528L21.482 3.54Z"
        fill="#444444"
      />
    </svg>
  );
};
export const TemplatesIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 12C1 3.74933 1.03614 1 5.5 1C9.96386 1 10 3.74933 10 12C10 20.2507 10.0142 23 5.5 23C0.985763 23 1 20.2507 1 12Z"
        stroke="#444444"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 5.5C14 2.12473 14.0361 1 18.5 1C22.9639 1 23 2.12473 23 5.5C23 8.87527 23.0142 10 18.5 10C13.9858 10 14 8.87527 14 5.5Z"
        stroke="#444444"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 18.5C14 15.1247 14.0361 14 18.5 14C22.9639 14 23 15.1247 23 18.5C23 21.8753 23.0142 23 18.5 23C13.9858 23 14 21.8753 14 18.5Z"
        stroke="#444444"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const AnalyticsIcon = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_46_20347)">
        <path
          d="M18.7132 12H14.0002C13.4697 12 12.961 11.7893 12.5859 11.4142C12.2109 11.0391 12.0002 10.5304 12.0002 10V5.274C12.0015 4.81398 11.8971 4.35981 11.6949 3.9466C11.4927 3.5334 11.1982 3.17222 10.8342 2.891C10.4892 2.61781 10.086 2.42757 9.65586 2.33498C9.22567 2.24239 8.77996 2.24992 8.35315 2.357C5.92881 2.95881 3.78248 4.37006 2.26912 6.35736C0.755766 8.34466 -0.0339719 10.789 0.0305135 13.2861C0.094999 15.7832 1.00985 18.1834 2.62376 20.09C4.23767 21.9965 6.45398 23.2951 8.90615 23.771C11.6633 24.2987 14.5178 23.7524 16.8852 22.2439C19.2526 20.7354 20.9537 18.3789 21.6402 15.657C21.7476 15.2296 21.7555 14.7833 21.663 14.3524C21.5706 13.9216 21.3804 13.5177 21.1072 13.172C20.8226 12.8085 20.4594 12.5141 20.0447 12.3111C19.6301 12.1081 19.1748 12.0018 18.7132 12ZM19.7012 15.168C19.3183 16.7099 18.5327 18.1224 17.4248 19.261C16.3169 20.3997 14.9265 21.2236 13.3957 21.6486C11.8649 22.0735 10.2487 22.0843 8.71235 21.6797C7.17604 21.2751 5.77477 20.4697 4.65186 19.3458C3.52895 18.222 2.7247 16.82 2.32137 15.2834C1.91805 13.7468 1.93012 12.1306 2.35635 10.6001C2.78258 9.06966 3.60768 7.67988 4.74725 6.57294C5.88683 5.466 7.29997 4.68161 8.84215 4.3C8.97409 4.26704 9.11191 4.26542 9.24457 4.29529C9.37724 4.32516 9.50107 4.38568 9.60615 4.472C9.73024 4.56661 9.83088 4.68853 9.90024 4.8283C9.96961 4.96808 10.0059 5.12196 10.0062 5.278V10C10.0062 11.0609 10.4276 12.0783 11.1777 12.8284C11.9279 13.5786 12.9453 14 14.0062 14H18.7182C18.8756 14.0006 19.0308 14.037 19.1721 14.1063C19.3134 14.1755 19.4372 14.276 19.5342 14.4C19.6192 14.5065 19.6784 14.6313 19.7072 14.7645C19.736 14.8978 19.7346 15.0359 19.7012 15.168Z"
          fill="#444444"
        />
        <path
          d="M23.651 7.446C23.1906 5.75348 22.2963 4.2105 21.0564 2.96978C19.8166 1.72906 18.2742 0.833593 16.582 0.372002C16.4046 0.324311 16.2217 0.300105 16.038 0.300002C15.7738 0.297491 15.5117 0.34737 15.2668 0.446755C15.022 0.546139 14.7993 0.69306 14.6115 0.879028C14.4238 1.065 14.2748 1.28632 14.1731 1.53022C14.0714 1.77412 14.019 2.03575 14.019 2.3V7C14.019 7.79565 14.3351 8.55871 14.8977 9.12132C15.4603 9.68393 16.2234 10 17.019 10H21.738C22.0467 9.99703 22.3505 9.92294 22.6259 9.78348C22.9013 9.64402 23.1408 9.44295 23.3259 9.19589C23.5109 8.94883 23.6365 8.66243 23.6929 8.35894C23.7493 8.05545 23.735 7.74305 23.651 7.446ZM21.153 8H17.015C16.7498 8 16.4955 7.89464 16.3079 7.70711C16.1204 7.51957 16.015 7.26522 16.015 7L16.007 2.307C16.0144 2.30171 16.023 2.29859 16.032 2.298H16.058C17.4201 2.66909 18.6611 3.39091 19.6571 4.39144C20.653 5.39198 21.3692 6.63622 21.734 8H21.153Z"
          fill="#444444"
        />
      </g>
      <defs>
        <clipPath id="clip0_46_20347">
          <rect width={24} height={24} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ChatsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0714 19.0699C16.0152 22.1263 11.4898 22.7867 7.78642 21.074C7.23971 20.8539 6.79148 20.676 6.36537 20.676C5.17849 20.683 3.70117 21.8339 2.93336 21.067C2.16555 20.2991 3.31726 18.8206 3.31726 17.6266C3.31726 17.2004 3.14642 16.7602 2.92632 16.2124C1.21283 12.5096 1.87411 7.98269 4.93026 4.92721C8.8316 1.02443 15.17 1.02443 19.0714 4.9262C22.9797 8.83501 22.9727 15.1681 19.0714 19.0699Z"
        stroke="#444444"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M15.9389 12.4121H15.9479"
        stroke="#444444"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M11.931 12.4121H11.94"
        stroke="#444444"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M7.92128 12.4121H7.93028"
        stroke="#444444"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AudienceIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.592 15.207C13.281 15.207 16.434 15.766 16.434 17.999C16.434 20.232 13.302 20.807 9.592 20.807C5.902 20.807 2.75 20.253 2.75 18.019C2.75 15.785 5.881 15.207 9.592 15.207Z"
        stroke="#444444"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.59108 12.02C7.16908 12.02 5.20508 10.057 5.20508 7.635C5.20508 5.213 7.16908 3.25 9.59108 3.25C12.0121 3.25 13.9761 5.213 13.9761 7.635C13.9851 10.048 12.0351 12.011 9.62208 12.02H9.59108Z"
        stroke="#444444"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M16.4844 10.8813C18.0854 10.6563 19.3184 9.28228 19.3214 7.61928C19.3214 5.98028 18.1264 4.62028 16.5594 4.36328"
        stroke="#444444"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M18.5957 14.7305C20.1467 14.9615 21.2297 15.5055 21.2297 16.6255C21.2297 17.3965 20.7197 17.8965 19.8957 18.2095"
        stroke="#444444"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SettingsIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8064 7.62358L20.184 6.54349C19.6574 5.62957 18.4905 5.31429 17.5753 5.83869V5.83869C17.1397 6.09531 16.6198 6.16812 16.1305 6.04106C15.6411 5.91399 15.2224 5.59749 14.9666 5.16134C14.8021 4.88412 14.7137 4.56836 14.7103 4.24601V4.24601C14.7251 3.72919 14.5302 3.22837 14.1698 2.85764C13.8094 2.48691 13.3143 2.27783 12.7973 2.27805H11.5433C11.0367 2.27804 10.5511 2.47988 10.1938 2.83891C9.83644 3.19795 9.63693 3.68456 9.63937 4.19109V4.19109C9.62435 5.23689 8.77224 6.07678 7.72632 6.07667C7.40397 6.07332 7.08821 5.98491 6.81099 5.82038V5.82038C5.89582 5.29598 4.72887 5.61126 4.20229 6.52519L3.5341 7.62358C3.00817 8.53636 3.31916 9.70258 4.22975 10.2323V10.2323C4.82166 10.574 5.18629 11.2056 5.18629 11.889C5.18629 12.5725 4.82166 13.204 4.22975 13.5458V13.5458C3.32031 14.0719 3.00898 15.2353 3.5341 16.1453V16.1453L4.16568 17.2346C4.4124 17.6798 4.82636 18.0083 5.31595 18.1474C5.80554 18.2866 6.3304 18.2249 6.77438 17.976V17.976C7.21084 17.7213 7.73094 17.6515 8.2191 17.7822C8.70725 17.9128 9.12299 18.233 9.37392 18.6716C9.53845 18.9489 9.62686 19.2646 9.63021 19.587V19.587C9.63021 20.6435 10.4867 21.5 11.5433 21.5H12.7973C13.8502 21.5 14.7053 20.6491 14.7103 19.5961V19.5961C14.7079 19.088 14.9086 18.6 15.2679 18.2407C15.6272 17.8814 16.1152 17.6806 16.6233 17.6831C16.9449 17.6917 17.2594 17.7797 17.5387 17.9394V17.9394C18.4515 18.4653 19.6177 18.1543 20.1474 17.2437V17.2437L20.8064 16.1453C21.0615 15.7075 21.1315 15.186 21.001 14.6963C20.8704 14.2067 20.55 13.7893 20.1108 13.5366V13.5366C19.6715 13.2839 19.3511 12.8665 19.2206 12.3769C19.09 11.8873 19.16 11.3658 19.4151 10.9279C19.581 10.6383 19.8211 10.3982 20.1108 10.2323V10.2323C21.0159 9.70286 21.3262 8.54346 20.8064 7.63274V7.63274V7.62358Z"
        stroke="#444444"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        opacity="0.4"
        cx="12.1747"
        cy="11.889"
        r="2.63616"
        stroke="#444444"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PricingIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_4812_656" fill="white">
        <path d="M10 0C4.48625 0 0 4.48625 0 10C0 15.5138 4.48625 20 10 20C15.5138 20 20 15.5138 20 10C20 4.48625 15.5138 0 10 0ZM10 18.75C5.175 18.75 1.25 14.825 1.25 10C1.25 5.175 5.175 1.25 10 1.25C14.825 1.25 18.75 5.175 18.75 10C18.75 14.825 14.825 18.75 10 18.75Z" />
      </mask>
      <path
        d="M10 -1.5C3.65782 -1.5 -1.5 3.65782 -1.5 10H1.5C1.5 5.31468 5.31468 1.5 10 1.5V-1.5ZM-1.5 10C-1.5 16.3422 3.65782 21.5 10 21.5V18.5C5.31468 18.5 1.5 14.6853 1.5 10H-1.5ZM10 21.5C16.3422 21.5 21.5 16.3422 21.5 10H18.5C18.5 14.6853 14.6853 18.5 10 18.5V21.5ZM21.5 10C21.5 3.65782 16.3422 -1.5 10 -1.5V1.5C14.6853 1.5 18.5 5.31468 18.5 10H21.5ZM10 17.25C6.00343 17.25 2.75 13.9966 2.75 10H-0.25C-0.25 15.6534 4.34657 20.25 10 20.25V17.25ZM2.75 10C2.75 6.00343 6.00343 2.75 10 2.75V-0.25C4.34657 -0.25 -0.25 4.34657 -0.25 10H2.75ZM10 2.75C13.9966 2.75 17.25 6.00343 17.25 10H20.25C20.25 4.34657 15.6534 -0.25 10 -0.25V2.75ZM17.25 10C17.25 13.9966 13.9966 17.25 10 17.25V20.25C15.6534 20.25 20.25 15.6534 20.25 10H17.25Z"
        fill="#444444"
        mask="url(#path-1-inside-1_4812_656)"
      />
      <path
        opacity="0.5"
        d="M10 9.375C8.98375 9.375 8.125 8.8025 8.125 8.125C8.125 7.4475 8.98375 6.875 10 6.875C10.575 6.875 11.1075 7.055 11.46 7.3675C11.5213 7.42213 11.5928 7.46412 11.6704 7.49105C11.748 7.51799 11.8302 7.52934 11.9121 7.52446C11.9941 7.51958 12.0744 7.49857 12.1482 7.46263C12.2221 7.42668 12.2881 7.37652 12.3425 7.315C12.5725 7.0575 12.5487 6.6625 12.29 6.4325C11.8525 6.04375 11.265 5.78125 10.625 5.6775V5C10.625 4.655 10.345 4.375 10 4.375C9.655 4.375 9.375 4.655 9.375 5V5.675C7.95 5.9075 6.875 6.9175 6.875 8.125C6.875 9.50375 8.2775 10.625 10 10.625C11.0163 10.625 11.875 11.1975 11.875 11.875C11.875 12.5525 11.0163 13.125 10 13.125C9.425 13.125 8.8925 12.945 8.54 12.6325C8.2825 12.4025 7.8875 12.425 7.6575 12.685C7.4275 12.9425 7.45125 13.3375 7.71 13.5675C8.1475 13.9575 8.735 14.2188 9.375 14.3237V15C9.375 15.345 9.655 15.625 10 15.625C10.345 15.625 10.625 15.345 10.625 15V14.325C12.05 14.0925 13.125 13.0825 13.125 11.875C13.125 10.4963 11.7225 9.375 10 9.375Z"
        fill="#444444"
      />
    </svg>
  );
};

const LockSvg = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="21.6667" height="22" rx="10.8333" fill="#FB5F66" />
      <path
        d="M14.9167 8.914V8.08333C14.9167 7.00037 14.4865 5.96175 13.7207 5.19598C12.9549 4.43021 11.9163 4 10.8333 4C9.75037 4 8.71175 4.43021 7.94598 5.19598C7.18021 5.96175 6.75 7.00037 6.75 8.08333V8.914C6.23046 9.14074 5.78825 9.51397 5.47746 9.98804C5.16666 10.4621 5.00075 11.0165 5 11.5833V15.0833C5.00093 15.8566 5.30851 16.5979 5.8553 17.1447C6.40208 17.6915 7.1434 17.9991 7.91667 18H13.75C14.5233 17.9991 15.2646 17.6915 15.8114 17.1447C16.3582 16.5979 16.6657 15.8566 16.6667 15.0833V11.5833C16.6659 11.0165 16.5 10.4621 16.1892 9.98804C15.8784 9.51397 15.4362 9.14074 14.9167 8.914ZM7.91667 8.08333C7.91667 7.30979 8.22396 6.56792 8.77094 6.02094C9.31792 5.47396 10.0598 5.16667 10.8333 5.16667C11.6069 5.16667 12.3487 5.47396 12.8957 6.02094C13.4427 6.56792 13.75 7.30979 13.75 8.08333V8.66667H7.91667V8.08333ZM15.5 15.0833C15.5 15.5475 15.3156 15.9926 14.9874 16.3208C14.6592 16.649 14.2141 16.8333 13.75 16.8333H7.91667C7.45254 16.8333 7.00742 16.649 6.67923 16.3208C6.35104 15.9926 6.16667 15.5475 6.16667 15.0833V11.5833C6.16667 11.1192 6.35104 10.6741 6.67923 10.3459C7.00742 10.0177 7.45254 9.83333 7.91667 9.83333H13.75C14.2141 9.83333 14.6592 10.0177 14.9874 10.3459C15.3156 10.6741 15.5 11.1192 15.5 11.5833V15.0833Z"
        fill="white"
      />
      <path
        d="M10.8353 11C10.548 11 10.2724 11.0966 10.0693 11.2685C9.86609 11.4404 9.75195 11.6736 9.75195 11.9167V13.75C9.75195 13.9931 9.86609 14.2263 10.0693 14.3982C10.2724 14.5701 10.548 14.6667 10.8353 14.6667C11.1226 14.6667 11.3982 14.5701 11.6013 14.3982C11.8045 14.2263 11.9186 13.9931 11.9186 13.75V11.9167C11.9186 11.6736 11.8045 11.4404 11.6013 11.2685C11.3982 11.0966 11.1226 11 10.8353 11Z"
        fill="white"
      />
    </svg>
  );
};

const OmniHomeIcon = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 5.724V2C22 1.73478 21.8946 1.48043 21.7071 1.29289C21.5196 1.10536 21.2652 1 21 1C20.7348 1 20.4804 1.10536 20.2929 1.29289C20.1054 1.48043 20 1.73478 20 2V4.366L14.797 0.855C13.9718 0.294823 12.9974 -0.00466156 12 -0.00466156C11.0026 -0.00466156 10.0282 0.294823 9.203 0.855L2.203 5.579C1.52429 6.03652 0.968409 6.65382 0.584264 7.3766C0.20012 8.09937 -0.000518241 8.90548 1.00529e-06 9.724V19C1.00529e-06 21.757 2.243 24 5 24H8C8.26522 24 8.51957 23.8946 8.70711 23.7071C8.89464 23.5196 9 23.2652 9 23V15C9 14.449 9.448 14 10 14H14C14.552 14 15 14.449 15 15V23C15 23.2652 15.1054 23.5196 15.2929 23.7071C15.4804 23.8946 15.7348 24 16 24H19C21.757 24 24 21.757 24 19V9.724C24.0004 8.94771 23.8198 8.18201 23.4727 7.48767C23.1255 6.79333 22.6213 6.18947 22 5.724ZM22 19C22 20.654 20.654 22 19 22H17V15C17 13.346 15.654 12 14 12H10C8.346 12 7 13.346 7 15V22H5C3.346 22 2 20.654 2 19V9.724C2 8.725 2.494 7.795 3.322 7.237L10.322 2.513C10.8168 2.17681 11.4013 1.99705 11.9995 1.99705C12.5977 1.99705 13.1822 2.17681 13.677 2.513L20.677 7.237C21.0844 7.51136 21.4181 7.88171 21.6486 8.3154C21.8791 8.7491 21.9995 9.23284 21.999 9.724L22 19Z"
      fill="#E6E6E6"
    />
  </svg>
);

const OmniIntegrationIcon = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 10C13.141 10 10 13.14 10 17C10 20.86 13.141 24 17 24C20.859 24 24 20.86 24 17C24 13.14 20.859 10 17 10ZM17 22C14.243 22 12 19.757 12 17C12 14.243 14.243 12 17 12C19.757 12 22 14.243 22 17C22 19.757 19.757 22 17 22ZM9 18.922V23C9 23.2652 8.89464 23.5196 8.70711 23.7071C8.51957 23.8946 8.26522 24 8 24C7.73478 24 7.48043 23.8946 7.29289 23.7071C7.10536 23.5196 7 23.2652 7 23V18.922C3.583 18.444 1 15.464 1 12V8C0.734784 8 0.48043 7.89464 0.292893 7.70711C0.105357 7.51957 0 7.26522 0 7C0 6.73478 0.105357 6.48043 0.292893 6.29289C0.48043 6.10536 0.734784 6 1 6H4V1C4 0.734784 4.10536 0.48043 4.29289 0.292893C4.48043 0.105357 4.73478 0 5 0C5.26522 0 5.51957 0.105357 5.70711 0.292893C5.89464 0.48043 6 0.734784 6 1V6H11V1C11 0.734784 11.1054 0.48043 11.2929 0.292893C11.4804 0.105357 11.7348 0 12 0C12.2652 0 12.5196 0.105357 12.7071 0.292893C12.8946 0.48043 13 0.734784 13 1V6H16C16.2652 6 16.5196 6.10536 16.7071 6.29289C16.8946 6.48043 17 6.73478 17 7C17 7.26522 16.8946 7.51957 16.7071 7.70711C16.5196 7.89464 16.2652 8 16 8H3V12C3 14.475 4.844 16.603 7.289 16.95C8.265 17.09 9 17.937 9 18.922ZM19.309 16.848C19.589 17.37 19.559 17.999 19.232 18.493C18.905 18.987 17.792 20.638 17.792 20.638C17.7198 20.7516 17.6255 20.8494 17.5146 20.9256C17.4037 21.0018 17.2786 21.0548 17.1467 21.0815C17.0148 21.1081 16.8789 21.1079 16.7472 21.0807C16.6154 21.0535 16.4904 21 16.3798 20.9234C16.2693 20.8468 16.1753 20.7486 16.1036 20.6348C16.0318 20.5209 15.9839 20.3938 15.9625 20.2609C15.9411 20.1281 15.9468 19.9923 15.9792 19.8617C16.0116 19.7311 16.07 19.6084 16.151 19.501L17.151 18.003H16.144C15.635 18.003 15.15 17.759 14.847 17.351C14.544 16.942 14.385 16.382 14.598 15.92C14.912 15.24 15.52 14.284 16.149 13.37C16.2991 13.1464 16.5319 12.9916 16.7961 12.9397C16.927 12.914 17.0616 12.9143 17.1923 12.9406C17.323 12.9669 17.4473 13.0187 17.558 13.093C17.6687 13.1673 17.7637 13.2627 17.8375 13.3738C17.9114 13.4848 17.9626 13.6093 17.9883 13.7401C18.014 13.871 18.0137 14.0056 17.9874 14.1363C17.9611 14.267 17.9093 14.3913 17.835 14.502L16.895 16.004H17.896C18.1861 16.0037 18.4708 16.0822 18.7197 16.2312C18.9686 16.3803 19.1723 16.5941 19.309 16.85V16.848Z"
      fill="#E6E6E6"
    />
  </svg>
);

const OmniAnalyticsIcon = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.7129 12H13.9999C13.4695 12 12.9608 11.7893 12.5857 11.4142C12.2106 11.0391 11.9999 10.5304 11.9999 10V5.274C12.0013 4.81398 11.8968 4.35982 11.6946 3.94661C11.4925 3.5334 11.198 3.17222 10.8339 2.891C10.4889 2.61781 10.0858 2.42758 9.65561 2.33499C9.22543 2.2424 8.77972 2.24993 8.35291 2.357C5.92856 2.95881 3.78224 4.37006 2.26888 6.35737C0.755522 8.34467 -0.034216 10.789 0.0302694 13.2861C0.0947548 15.7832 1.0096 18.1835 2.62351 20.09C4.23743 21.9965 6.45373 23.2951 8.90591 23.771C11.663 24.2987 14.5176 23.7524 16.885 22.2439C19.2524 20.7354 20.9535 18.3789 21.6399 15.657C21.7474 15.2296 21.7552 14.7833 21.6628 14.3524C21.5704 13.9216 21.3802 13.5177 21.1069 13.172C20.8224 12.8085 20.4591 12.5141 20.0445 12.3111C19.6298 12.1081 19.1746 12.0018 18.7129 12ZM19.7009 15.168C19.318 16.7099 18.5325 18.1224 17.4246 19.261C16.3167 20.3997 14.9262 21.2236 13.3954 21.6486C11.8646 22.0735 10.2484 22.0843 8.71211 21.6797C7.1758 21.2751 5.77453 20.4697 4.65162 19.3458C3.52871 18.222 2.72446 16.82 2.32113 15.2834C1.9178 13.7468 1.92987 12.1306 2.35611 10.6001C2.78234 9.06966 3.60744 7.67989 4.74701 6.57294C5.88658 5.466 7.29973 4.68161 8.84191 4.3C8.97384 4.26704 9.11166 4.26543 9.24433 4.2953C9.377 4.32516 9.50083 4.38568 9.60591 4.472C9.73 4.56661 9.83063 4.68853 9.9 4.82831C9.96937 4.96808 10.0056 5.12196 10.0059 5.278V10C10.0059 11.0609 10.4273 12.0783 11.1775 12.8284C11.9276 13.5786 12.945 14 14.0062 14H18.7179C18.8753 14.0006 19.0305 14.037 19.1719 14.1063C19.3132 14.1755 19.437 14.276 19.5339 14.4C19.6189 14.5066 19.6781 14.6313 19.7069 14.7645C19.7357 14.8978 19.7343 15.0359 19.7009 15.168Z"
      fill="#E6E6E6"
    />
    <path
      d="M23.6508 7.446C23.1904 5.75348 22.296 4.2105 21.0562 2.96978C19.8163 1.72906 18.274 0.833593 16.5818 0.372002C16.4044 0.324311 16.2215 0.300105 16.0378 0.300002C15.7736 0.297491 15.5114 0.34737 15.2666 0.446755C15.0217 0.546139 14.799 0.69306 14.6113 0.879028C14.4236 1.065 14.2745 1.28632 14.1728 1.53022C14.0711 1.77412 14.0188 2.03575 14.0188 2.3V7C14.0188 7.79565 14.3349 8.55871 14.8975 9.12132C15.4601 9.68393 16.2231 10 17.0188 10H21.7378C22.0465 9.99703 22.3503 9.92294 22.6257 9.78348C22.9011 9.64402 23.1406 9.44295 23.3256 9.19589C23.5107 8.94883 23.6363 8.66243 23.6927 8.35894C23.7491 8.05545 23.7347 7.74305 23.6508 7.446ZM21.1528 8H17.0148C16.7496 8 16.4952 7.89464 16.3077 7.70711C16.1202 7.51957 16.0148 7.26522 16.0148 7L16.0068 2.307C16.0141 2.30171 16.0228 2.29859 16.0318 2.298H16.0578C17.4199 2.66909 18.6609 3.39091 19.6568 4.39144C20.6528 5.39198 21.3689 6.63622 21.7338 8H21.1528Z"
      fill="#E6E6E6"
    />
  </svg>
);

const OmniChatsIcon = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.9999 11.247C23.8553 8.90702 23.0291 6.66051 21.6231 4.78442C20.2171 2.90834 18.2929 1.48469 16.0876 0.688994C13.8823 -0.106704 11.4924 -0.239667 9.21247 0.306495C6.93253 0.852657 4.86225 2.05407 3.25686 3.76262C1.65147 5.47117 0.581149 7.61216 0.17785 9.92166C-0.225449 12.2312 0.0559044 14.6082 0.987224 16.7597C1.91854 18.9112 3.45912 20.7432 5.41902 22.0298C7.37892 23.3163 9.67246 24.0012 12.0169 24H18.9999C20.3256 23.9987 21.5966 23.4715 22.534 22.5341C23.4714 21.5967 23.9986 20.3257 23.9999 19V11.247ZM21.9999 19C21.9999 19.7957 21.6838 20.5587 21.1212 21.1213C20.5586 21.6839 19.7956 22 18.9999 22H12.0169C10.6058 21.9994 9.21075 21.7013 7.92261 21.1253C6.63446 20.5493 5.48218 19.7082 4.54091 18.657C3.59508 17.6063 2.88484 16.3655 2.4578 15.0178C2.03077 13.6701 1.89681 12.2467 2.06491 10.843C2.33034 8.62894 3.3251 6.56619 4.89235 4.97992C6.4596 3.39366 8.51021 2.37411 10.7209 2.082C11.1521 2.02795 11.5863 2.00056 12.0209 2C14.3514 1.99364 16.6097 2.8079 18.3999 4.3C19.4454 5.16894 20.3036 6.24115 20.9224 7.45163C21.5413 8.66211 21.9078 9.98564 21.9999 11.342V19Z"
      fill="#E6E6E6"
    />
    <path
      d="M8 9H12C12.2652 9 12.5196 8.89464 12.7071 8.70711C12.8946 8.51957 13 8.26522 13 8C13 7.73478 12.8946 7.48043 12.7071 7.29289C12.5196 7.10536 12.2652 7 12 7H8C7.73478 7 7.48043 7.10536 7.29289 7.29289C7.10536 7.48043 7 7.73478 7 8C7 8.26522 7.10536 8.51957 7.29289 8.70711C7.48043 8.89464 7.73478 9 8 9ZM16 11H8C7.73478 11 7.48043 11.1054 7.29289 11.2929C7.10536 11.4804 7 11.7348 7 12C7 12.2652 7.10536 12.5196 7.29289 12.7071C7.48043 12.8946 7.73478 13 8 13H16C16.2652 13 16.5196 12.8946 16.7071 12.7071C16.8946 12.5196 17 12.2652 17 12C17 11.7348 16.8946 11.4804 16.7071 11.2929C16.5196 11.1054 16.2652 11 16 11ZM16 15H8C7.73478 15 7.48043 15.1054 7.29289 15.2929C7.10536 15.4804 7 15.7348 7 16C7 16.2652 7.10536 16.5196 7.29289 16.7071C7.48043 16.8946 7.73478 17 8 17H16C16.2652 17 16.5196 16.8946 16.7071 16.7071C16.8946 16.5196 17 16.2652 17 16C17 15.7348 16.8946 15.4804 16.7071 15.2929C16.5196 15.1054 16.2652 15 16 15Z"
      fill="#E6E6E6"
    />
  </svg>
);

const OmniAudienceIcon = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 16C11.2089 16 10.4355 15.7654 9.77772 15.3259C9.11992 14.8864 8.60723 14.2616 8.30448 13.5307C8.00173 12.7998 7.92252 11.9956 8.07686 11.2196C8.2312 10.4437 8.61216 9.73099 9.17157 9.17158C9.73098 8.61217 10.4437 8.2312 11.2196 8.07686C11.9956 7.92252 12.7998 8.00173 13.5307 8.30448C14.2616 8.60723 14.8864 9.11993 15.3259 9.77772C15.7654 10.4355 16 11.2089 16 12C16 13.0609 15.5786 14.0783 14.8284 14.8284C14.0783 15.5786 13.0609 16 12 16ZM12 10C11.6044 10 11.2178 10.1173 10.8889 10.3371C10.56 10.5568 10.3036 10.8692 10.1522 11.2346C10.0009 11.6001 9.96126 12.0022 10.0384 12.3902C10.1156 12.7781 10.3061 13.1345 10.5858 13.4142C10.8655 13.6939 11.2219 13.8844 11.6098 13.9616C11.9978 14.0387 12.3999 13.9991 12.7654 13.8478C13.1308 13.6964 13.4432 13.44 13.6629 13.1111C13.8827 12.7822 14 12.3956 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10ZM18 23C18 21.4087 17.3679 19.8826 16.2426 18.7574C15.1174 17.6321 13.5913 17 12 17C10.4087 17 8.88258 17.6321 7.75736 18.7574C6.63214 19.8826 6 21.4087 6 23C6 23.2652 6.10536 23.5196 6.29289 23.7071C6.48043 23.8946 6.73478 24 7 24C7.26522 24 7.51957 23.8946 7.70711 23.7071C7.89464 23.5196 8 23.2652 8 23C8 21.9391 8.42143 20.9217 9.17157 20.1716C9.92172 19.4214 10.9391 19 12 19C13.0609 19 14.0783 19.4214 14.8284 20.1716C15.5786 20.9217 16 21.9391 16 23C16 23.2652 16.1054 23.5196 16.2929 23.7071C16.4804 23.8946 16.7348 24 17 24C17.2652 24 17.5196 23.8946 17.7071 23.7071C17.8946 23.5196 18 23.2652 18 23ZM18 8C17.2089 8 16.4355 7.76541 15.7777 7.32588C15.1199 6.88636 14.6072 6.26164 14.3045 5.53074C14.0017 4.79983 13.9225 3.99557 14.0769 3.21964C14.2312 2.44372 14.6122 1.73098 15.1716 1.17157C15.731 0.612165 16.4437 0.231202 17.2196 0.0768607C17.9956 -0.0774802 18.7998 0.00173312 19.5307 0.304484C20.2616 0.607234 20.8864 1.11992 21.3259 1.77772C21.7654 2.43552 22 3.20888 22 4C22 5.06087 21.5786 6.07828 20.8284 6.82843C20.0783 7.57858 19.0609 8 18 8ZM18 2C17.6044 2 17.2178 2.1173 16.8889 2.33706C16.56 2.55683 16.3036 2.86918 16.1522 3.23464C16.0009 3.60009 15.9613 4.00222 16.0384 4.39018C16.1156 4.77815 16.3061 5.13451 16.5858 5.41422C16.8655 5.69392 17.2219 5.8844 17.6098 5.96157C17.9978 6.03874 18.3999 5.99914 18.7654 5.84776C19.1308 5.69639 19.4432 5.44004 19.6629 5.11114C19.8827 4.78224 20 4.39557 20 4C20 3.46957 19.7893 2.96086 19.4142 2.58579C19.0391 2.21072 18.5304 2 18 2ZM24 15C23.9984 13.4092 23.3658 11.884 22.2409 10.7591C21.116 9.63424 19.5908 9.00159 18 9C17.7348 9 17.4804 9.10536 17.2929 9.2929C17.1054 9.48043 17 9.73479 17 10C17 10.2652 17.1054 10.5196 17.2929 10.7071C17.4804 10.8946 17.7348 11 18 11C19.0609 11 20.0783 11.4214 20.8284 12.1716C21.5786 12.9217 22 13.9391 22 15C22 15.2652 22.1054 15.5196 22.2929 15.7071C22.4804 15.8946 22.7348 16 23 16C23.2652 16 23.5196 15.8946 23.7071 15.7071C23.8946 15.5196 24 15.2652 24 15ZM6 8C5.20887 8 4.43552 7.76541 3.77772 7.32588C3.11992 6.88636 2.60723 6.26164 2.30448 5.53074C2.00173 4.79983 1.92252 3.99557 2.07686 3.21964C2.2312 2.44372 2.61216 1.73098 3.17157 1.17157C3.73098 0.612165 4.44371 0.231202 5.21964 0.0768607C5.99556 -0.0774802 6.79983 0.00173312 7.53073 0.304484C8.26164 0.607234 8.88635 1.11992 9.32588 1.77772C9.7654 2.43552 10 3.20888 10 4C10 5.06087 9.57857 6.07828 8.82843 6.82843C8.07828 7.57858 7.06087 8 6 8ZM6 2C5.60444 2 5.21776 2.1173 4.88886 2.33706C4.55996 2.55683 4.30362 2.86918 4.15224 3.23464C4.00087 3.60009 3.96126 4.00222 4.03843 4.39018C4.1156 4.77815 4.30608 5.13451 4.58579 5.41422C4.86549 5.69392 5.22186 5.8844 5.60982 5.96157C5.99778 6.03874 6.39991 5.99914 6.76537 5.84776C7.13082 5.69639 7.44318 5.44004 7.66294 5.11114C7.8827 4.78224 8 4.39557 8 4C8 3.46957 7.78929 2.96086 7.41421 2.58579C7.03914 2.21072 6.53043 2 6 2ZM2 15C2 13.9391 2.42143 12.9217 3.17157 12.1716C3.92172 11.4214 4.93913 11 6 11C6.26522 11 6.51957 10.8946 6.70711 10.7071C6.89464 10.5196 7 10.2652 7 10C7 9.73479 6.89464 9.48043 6.70711 9.2929C6.51957 9.10536 6.26522 9 6 9C4.40919 9.00159 2.88399 9.63424 1.75911 10.7591C0.63424 11.884 0.00158843 13.4092 0 15C0 15.2652 0.105357 15.5196 0.292893 15.7071C0.48043 15.8946 0.734784 16 1 16C1.26522 16 1.51957 15.8946 1.70711 15.7071C1.89464 15.5196 2 15.2652 2 15Z"
      fill="#E6E6E6"
    />
  </svg>
);

const OmniSettingsIcon = () => (
  <svg
    width={22}
    height={24}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 8C10.2089 8 9.43552 8.2346 8.77772 8.67412C8.11993 9.11365 7.60723 9.73836 7.30448 10.4693C7.00173 11.2002 6.92252 12.0044 7.07686 12.7804C7.2312 13.5563 7.61216 14.269 8.17157 14.8284C8.73098 15.3878 9.44372 15.7688 10.2196 15.9231C10.9956 16.0775 11.7998 15.9983 12.5307 15.6955C13.2616 15.3928 13.8864 14.8801 14.3259 14.2223C14.7654 13.5645 15 12.7911 15 12C15 10.9391 14.5786 9.92172 13.8284 9.17157C13.0783 8.42143 12.0609 8 11 8ZM11 14C10.6044 14 10.2178 13.8827 9.88886 13.6629C9.55996 13.4432 9.30362 13.1308 9.15224 12.7654C9.00087 12.3999 8.96126 11.9978 9.03843 11.6098C9.1156 11.2219 9.30608 10.8655 9.58579 10.5858C9.86549 10.3061 10.2219 10.1156 10.6098 10.0384C10.9978 9.96126 11.3999 10.0009 11.7654 10.1522C12.1308 10.3036 12.4432 10.56 12.6629 10.8889C12.8827 11.2178 13 11.6044 13 12C13 12.5304 12.7893 13.0391 12.4142 13.4142C12.0391 13.7893 11.5304 14 11 14Z"
      fill="white"
    />
    <path
      d="M20.294 13.9L19.85 13.644C20.0499 12.5564 20.0499 11.4416 19.85 10.354L20.294 10.098C20.6355 9.90102 20.9348 9.63871 21.1748 9.32606C21.4149 9.01341 21.591 8.65654 21.6932 8.27582C21.7953 7.8951 21.8215 7.49799 21.7702 7.10716C21.7188 6.71633 21.591 6.33944 21.394 5.998C21.1971 5.65656 20.9348 5.35727 20.6221 5.1172C20.3095 4.87714 19.9526 4.70101 19.5719 4.59886C19.1911 4.49672 18.794 4.47056 18.4032 4.52189C18.0124 4.57321 17.6355 4.70102 17.294 4.898L16.849 5.155C16.0086 4.43692 15.0427 3.88025 14 3.513V3C14 2.20435 13.684 1.44129 13.1214 0.87868C12.5588 0.31607 11.7957 0 11 0C10.2044 0 9.44133 0.31607 8.87872 0.87868C8.31611 1.44129 8.00004 2.20435 8.00004 3V3.513C6.95743 3.88157 5.99189 4.4396 5.15204 5.159L4.70504 4.9C4.01548 4.50218 3.19612 4.39457 2.42723 4.60086C1.65833 4.80715 1.00287 5.31044 0.605043 6C0.207218 6.68956 0.0996151 7.50892 0.305905 8.27782C0.512195 9.04672 1.01548 9.70218 1.70504 10.1L2.14904 10.356C1.94915 11.4436 1.94915 12.5584 2.14904 13.646L1.70504 13.902C1.01548 14.2998 0.512195 14.9553 0.305905 15.7242C0.0996151 16.4931 0.207218 17.3124 0.605043 18.002C1.00287 18.6916 1.65833 19.1948 2.42723 19.4011C3.19612 19.6074 4.01548 19.4998 4.70504 19.102L5.15004 18.845C5.99081 19.5632 6.95702 20.1199 8.00004 20.487V21C8.00004 21.7956 8.31611 22.5587 8.87872 23.1213C9.44133 23.6839 10.2044 24 11 24C11.7957 24 12.5588 23.6839 13.1214 23.1213C13.684 22.5587 14 21.7956 14 21V20.487C15.0427 20.1184 16.0082 19.5604 16.848 18.841L17.295 19.099C17.9846 19.4968 18.804 19.6044 19.5729 19.3981C20.3418 19.1918 20.9972 18.6886 21.395 17.999C21.7929 17.3094 21.9005 16.4901 21.6942 15.7212C21.4879 14.9523 20.9846 14.2968 20.295 13.899L20.294 13.9ZM17.746 10.124C18.0847 11.3511 18.0847 12.6469 17.746 13.874C17.6869 14.0876 17.7004 14.3147 17.7844 14.5198C17.8684 14.7249 18.0181 14.8963 18.21 15.007L19.294 15.633C19.5239 15.7656 19.6916 15.9841 19.7603 16.2403C19.829 16.4966 19.7932 16.7697 19.6605 16.9995C19.5279 17.2293 19.3095 17.397 19.0532 17.4658C18.7969 17.5345 18.5239 17.4986 18.294 17.366L17.208 16.738C17.0159 16.6267 16.7923 16.5826 16.5723 16.6124C16.3523 16.6423 16.1485 16.7445 15.993 16.903C15.103 17.8117 13.9816 18.46 12.75 18.778C12.5351 18.8333 12.3446 18.9585 12.2086 19.1339C12.0727 19.3094 11.9989 19.525 11.999 19.747V21C11.999 21.2652 11.8937 21.5196 11.7062 21.7071C11.5186 21.8946 11.2643 22 10.999 22C10.7338 22 10.4795 21.8946 10.2919 21.7071C10.1044 21.5196 9.99904 21.2652 9.99904 21V19.748C9.99915 19.526 9.92542 19.3104 9.78945 19.1349C9.65348 18.9595 9.46301 18.8343 9.24804 18.779C8.01639 18.4597 6.89537 17.81 6.00604 16.9C5.85057 16.7415 5.64678 16.6393 5.4268 16.6094C5.20682 16.5796 4.98315 16.6237 4.79104 16.735L3.70704 17.362C3.59327 17.4287 3.46743 17.4722 3.33677 17.4901C3.2061 17.508 3.0732 17.4998 2.9457 17.4661C2.8182 17.4324 2.69862 17.3738 2.59386 17.2937C2.4891 17.2136 2.40122 17.1135 2.33528 16.9993C2.26934 16.8851 2.22664 16.759 2.20964 16.6282C2.19264 16.4974 2.20168 16.3646 2.23623 16.2373C2.27079 16.11 2.33017 15.9909 2.41098 15.8866C2.49178 15.7824 2.5924 15.6952 2.70704 15.63L3.79104 15.004C3.98299 14.8933 4.13272 14.7219 4.2167 14.5168C4.30069 14.3117 4.31417 14.0846 4.25504 13.871C3.9164 12.6439 3.9164 11.3481 4.25504 10.121C4.31311 9.90788 4.29898 9.68153 4.21486 9.47729C4.13074 9.27305 3.98136 9.10241 3.79004 8.992L2.70604 8.366C2.47623 8.23339 2.30851 8.01492 2.23978 7.75865C2.17105 7.50239 2.20693 7.22931 2.33954 6.9995C2.47215 6.76969 2.69062 6.60197 2.94689 6.53324C3.20316 6.46451 3.47623 6.50039 3.70604 6.633L4.79204 7.261C4.98362 7.37251 5.20682 7.41721 5.42657 7.38807C5.64632 7.35893 5.85015 7.25759 6.00604 7.1C6.89613 6.19134 8.01747 5.54302 9.24904 5.225C9.46467 5.16956 9.65564 5.04375 9.79168 4.8675C9.92771 4.69125 10.001 4.47464 10 4.252V3C10 2.73478 10.1054 2.48043 10.2929 2.29289C10.4805 2.10536 10.7348 2 11 2C11.2653 2 11.5196 2.10536 11.7071 2.29289C11.8947 2.48043 12 2.73478 12 3V4.252C11.9999 4.47396 12.0737 4.68964 12.2096 4.86508C12.3456 5.04052 12.5361 5.16573 12.751 5.221C13.9831 5.54015 15.1044 6.18988 15.994 7.1C16.1495 7.25847 16.3533 7.36069 16.5733 7.39057C16.7933 7.42044 17.0169 7.37626 17.209 7.265L18.293 6.638C18.4068 6.5713 18.5327 6.52777 18.6633 6.5099C18.794 6.49204 18.9269 6.50019 19.0544 6.5339C19.1819 6.56761 19.3015 6.6262 19.4062 6.70631C19.511 6.78642 19.5989 6.88646 19.6648 7.00067C19.7307 7.11488 19.7734 7.24101 19.7904 7.37179C19.8074 7.50257 19.7984 7.63542 19.7639 7.76269C19.7293 7.88997 19.6699 8.00915 19.5891 8.11337C19.5083 8.2176 19.4077 8.30482 19.293 8.37L18.209 8.996C18.0181 9.10671 17.8691 9.27748 17.7854 9.48169C17.7016 9.68591 17.6878 9.9121 17.746 10.125V10.124Z"
      fill="white"
    />
  </svg>
);

const OmniPricingIcon = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0C5.383 0 0 5.383 0 12C0 18.617 5.383 24 12 24C18.617 24 24 18.617 24 12C24 5.383 18.617 0 12 0ZM12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22ZM16 14C16 15.654 14.654 17 13 17V18C13 18.2652 12.8946 18.5196 12.7071 18.7071C12.5196 18.8946 12.2652 19 12 19C11.7348 19 11.4804 18.8946 11.2929 18.7071C11.1054 18.5196 11 18.2652 11 18V17H10.732C10.2057 16.9991 9.68885 16.8602 9.23299 16.5972C8.77713 16.3341 8.3982 15.9562 8.134 15.501C8.06382 15.3872 8.01715 15.2606 7.99676 15.1285C7.97637 14.9964 7.98267 14.8615 8.01529 14.7319C8.0479 14.6023 8.10617 14.4805 8.18666 14.3738C8.26714 14.2671 8.3682 14.1776 8.48386 14.1106C8.59953 14.0436 8.72745 14.0005 8.86006 13.9838C8.99268 13.9671 9.1273 13.9771 9.25596 14.0133C9.38463 14.0495 9.50473 14.1112 9.60916 14.1946C9.7136 14.278 9.80025 14.3815 9.864 14.499C10.043 14.809 10.375 15 10.731 15H12.999C13.2642 15 13.5186 14.8946 13.7061 14.7071C13.8936 14.5196 13.999 14.2652 13.999 14C13.9995 13.8175 13.9349 13.6407 13.8169 13.5014C13.6989 13.3622 13.5352 13.2695 13.355 13.24L10.314 12.733C9.66625 12.627 9.07746 12.2937 8.65321 11.7928C8.22897 11.292 7.99704 10.6564 7.999 10C7.999 8.346 9.345 7 10.999 7V6C10.999 5.73478 11.1044 5.48043 11.2919 5.29289C11.4794 5.10536 11.7338 5 11.999 5C12.2642 5 12.5186 5.10536 12.7061 5.29289C12.8936 5.48043 12.999 5.73478 12.999 6V7H13.267C14.334 7 15.33 7.575 15.865 8.5C15.9364 8.61379 15.9841 8.7408 16.0053 8.87344C16.0265 9.00608 16.0208 9.14164 15.9885 9.27202C15.9562 9.4024 15.8979 9.52493 15.8172 9.6323C15.7365 9.73967 15.635 9.82968 15.5187 9.89696C15.4024 9.96423 15.2738 10.0074 15.1405 10.0239C15.0072 10.0403 14.8719 10.0298 14.7428 9.99282C14.6136 9.95586 14.4932 9.89326 14.3888 9.80877C14.2844 9.72427 14.1981 9.6196 14.135 9.501C14.0468 9.34911 13.9204 9.223 13.7682 9.13527C13.6161 9.04753 13.4436 9.00123 13.268 9.001H11C10.448 9.001 10 9.45 10 10.001C10 10.379 10.271 10.699 10.644 10.761L13.685 11.268C14.3328 11.374 14.9215 11.7073 15.3458 12.2082C15.77 12.709 16.002 13.3446 16 14.001V14Z"
      fill="#E6E6E6"
    />
  </svg>
);

const NewOmniLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
  >
    <g clipPath="url(#clip0_3115_127796)">
      <path
        d="M31.9911 15.3889C33.8587 14.5627 36.0774 15.4202 36.509 17.4311C37.1563 20.4471 37.0548 23.5984 36.186 26.5977C34.9694 30.7976 32.3261 34.4313 28.7195 36.8618C25.113 39.2923 20.7734 40.3642 16.4617 39.8898C12.1501 39.4154 8.14155 37.4249 5.13915 34.2673C2.13675 31.1097 0.332014 26.9865 0.0414887 22.6208C-0.249037 18.2551 0.993165 13.9256 3.55024 10.3914C6.10737 6.85724 9.81616 4.344 14.0263 3.29251C17.0329 2.54154 20.1582 2.57027 23.1183 3.34821C25.0919 3.86686 25.8489 6.13871 24.953 7.987C24.0569 9.8352 21.8309 10.529 19.8065 10.2796C18.4778 10.1159 17.1204 10.1952 15.8012 10.5247C13.2751 11.1557 11.0499 12.6636 9.51564 14.7841C7.98133 16.9046 7.23606 19.5023 7.41034 22.1218C7.58463 24.7411 8.66746 27.215 10.4689 29.1096C12.2704 31.0042 14.6755 32.1985 17.2625 32.4832C19.8495 32.7678 22.4533 32.1246 24.6172 30.6664C26.7811 29.208 28.3671 27.0278 29.097 24.5079C29.4782 23.1918 29.6133 21.8271 29.5064 20.4809C29.3436 18.43 30.1233 16.2151 31.9911 15.3889Z"
        fill="#FB5F66"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.0787 1.93977C35.5149 -0.64659 31.3583 -0.646587 28.7946 1.93977C26.897 3.85406 26.404 6.64867 27.3153 9.02047C26.8735 10.5755 25.9084 12.0315 24.3756 13.2653C23.7161 13.7962 22.809 14.0521 21.8415 14.2028C18.9605 12.9394 15.4836 13.4961 13.1277 15.8728C10.0512 18.9764 10.0512 24.0084 13.1277 27.112C16.2041 30.2156 21.1921 30.2156 24.2686 27.112C26.5798 24.7804 27.1547 21.3604 25.9932 18.4873C26.4072 17.3342 26.9632 16.1674 27.8189 15.2723C28.9638 14.1173 30.4609 13.4847 31.6917 13.0085C33.8934 13.6186 36.3487 13.051 38.0787 11.3058C40.6424 8.71943 40.6424 4.52612 38.0787 1.93977Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3115_127796">
        <rect width={40} height={40} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
